import { Toast, ToastMessage } from 'primereact/toast';
import { FxTranslate } from '../../core/translate';
import { IResponse } from '../../services/model';
import { Response } from '../../model';

class AlertService {
  growl?: Toast;

  SetToast = (e: Toast) => {
    this.growl = e;
  }

  /** Muestra uno o mas mensajes en pantalla */
  show = (message: ToastMessage | ToastMessage[]) => {
    this.growl && this.growl.show(message);
  }

  /** muestra un mensaje de error */
  error(title: string, detail?: string): any {
    //console.warn("ERROR:", title, detail);
    this.show({ severity: 'error', summary: title, detail: `${detail ?? ''}`, life: 5000 });
  }

  /** muestra un mensaje de error ocurrido por una excepción no controlada */
  exception(t: FxTranslate, ex: unknown): any {
    //console.error("EXCEPTION:", ex);
    this.show({ severity: 'error', summary: t('@Id#ErrorInesperado'), detail: `${ex}`, life: 5000 });
  }

  /** muestra un mensaje */
  info(title: string, detail: string): any {
    this.show({ severity: 'info', summary: title, detail: `${detail ?? ''}`, life: 5000 });
  }

  /** muestra un mensaje */
  success(title: string, detail: string): any {
    this.show({ severity: 'success', summary: title, detail: `${detail ?? ''}`, life: 5000 });
  }

  /** muestra los mensajes de un IResponse */
  reponse(res: IResponse<any> | Response<any>, t?: FxTranslate) {
    if (!res.error && !res.messages) return;

    if(!!res.error) {
      const text = !!t && res.error.startsWith("@") ? t(res.error) : res.error;
      this.error("Error", text);
    } else if(!!res.messages && res.messages.length > 0) {
      for(let i = 0; i < res.messages.length; i++) {
        const msg = res.messages[i];
        if (msg.esError) {
          this.error("Error", msg.text);
          console.error("Alert", "Error", msg.text, "tag", msg.tag)
        } else {
          this.info("Info", msg.text);
          console.warn("Alert", "Error", msg.text, "tag", msg.tag)
        }
      }
    }
  }

  /** Cierra todos los mensajes en pantalla */
  clear = () => this.growl && this.growl.clear();
}

const Alert : AlertService = new AlertService();

export default Alert;